import api from "../api";

export function getHomePageContent() {
    return api.get("/home-page");
}

interface UpdateHomePageSectionPayload {
    id: number;
    title?: string;
    left_text?: string;
    right_text?: string;
    image?: File;
}

export function updateHomePageSection({
                                          id,
                                          title,
                                          left_text,
                                          right_text,
                                          image,
                                      }: UpdateHomePageSectionPayload) {
    const formData = new FormData();

    formData.append("id", String(id));

    if (title !== undefined) {
        formData.append("title", title);
    }

    if (left_text !== undefined) {
        formData.append("left_text", left_text);
    }

    if (right_text !== undefined) {
        formData.append("right_text", right_text);
    }

    if (image) {
        formData.append("image", image);
    }

    return api.post("/home-page/update", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}

interface CoreCapabilityPayload {
    top_text: string;
    bottom_text: string;
    right_text: string;
    position: number;
    image: File;
}

export function getCoreCapabilities() {
    return api.get("/core-capabilities");
}

export function addCoreCapability({
                                      top_text,
                                      bottom_text,
                                      right_text,
                                      position,
                                      image,
                                  }: CoreCapabilityPayload) {
    const formData = new FormData();

    formData.append("top_text", top_text);
    formData.append("bottom_text", bottom_text);
    formData.append("right_text", right_text);
    formData.append("position", String(position));
    formData.append("image", image);

    return api.post("/core-capabilities/add", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}

interface EditCoreCapabilityPayload {
    id: number;
    top_text: string;
    bottom_text: string;
    right_text: string;
    position: number;
    image?: File;
}

export function editCoreCapability({
                                       id,
                                       top_text,
                                       bottom_text,
                                       right_text,
                                       position,
                                       image,
                                   }: EditCoreCapabilityPayload) {
    const formData = new FormData();

    formData.append("id", String(id));
    formData.append("top_text", top_text);
    formData.append("bottom_text", bottom_text);
    formData.append("right_text", right_text);
    formData.append("position", String(position));

    if (image) {
        formData.append("image", image);
    }

    return api.post("/core-capabilities/update", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}


